export default {
      id: "pending-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#pending",
      toString: function () {
        return this.url;
      }
    }